import {NuxtIcon} from "#components";
import {h} from "vue";
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 20 20"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", { d: "M10 0C4.473 0 0 4.473 0 10s4.473 10 10 10 10-4.473 10-10S15.527 0 10 0m0 1.5c4.722 0 8.5 3.778 8.5 8.5s-3.778 8.5-8.5 8.5A8.465 8.465 0 0 1 1.5 10c0-4.722 3.778-8.5 8.5-8.5" }, null, -1),
    _createElementVNode("path", { d: "M12.605 4.25c-2 0-3.691 1.527-3.691 3.467v2.758H6v1.5h2.914V20h1.5v-8.025h3.326v-1.5h-3.326V7.717c0-1.062.94-1.967 2.191-1.967H15v-1.5z" }, null, -1)
  ])))
}
export default { render() { return h(NuxtIcon, {icon: {render}, name: "facebook2"}) } }